var $ = jQuery;

/* Initiate the superfish submenu */
$( '.sf-menu' ).supersubs( {
  minWidth:	12,	 // minimum width of submenus in em units
  maxWidth:	27,	 // maximum width of submenus in em units
  extraWidth:	1	 // extra width can ensure lines don't sometimes turn over
} ).superfish();	

/* Sticky Header */
if ( $(window).scrollTop() <= 300 ) {
  $( 'header' ).removeClass( '__sticky' );
} else {
  $( 'header' ).addClass( '__sticky' );
}
$( window ).scroll( function() {
  if ( $(window).scrollTop() <= 300 ) {
    $( 'header' ).removeClass( '__sticky' );
  } else {
    $( 'header' ).addClass( '__sticky' );
  }
} );

/* Initiate the moby */
var mobyMenu = new Moby( {
  menu              : $( '#mobile-menu' ), // The menu that will be cloned
  mobyTrigger       : $( '#open-mobile-menu' ), // Button that will trigger the Moby menu to open
  subMenuOpenIcon   : '<i class="fas fa-caret-down"></i>',
	subMenuCloseIcon  : '<i class="fas fa-caret-up"></i>',
  template          : '<div class="moby-close"><span class="moby-close-icon"></span></div><div class="moby-wrap"><div class="moby-menu"></div></div>'
} );